export const hiIN = {
  ANSWER: {
    CARRIER: {
      "3PL": "3PL",
      BREAD: "ब्रेड",
      COKE: "कोक",
      DSD: "DSD",
      FLOWERS: "फूल",
      GFS: "GFS",
      LCL: "LCL",
      MEAT: "मांस",
      PEPSI: "पेप्सी",
    },
    DRIVER_TYPE: {
      CONTRACTOR: "ठेकेदार",
      DELIVERY: "डिलिवरी",
      FLEET_DRIVER: "वाहन ड्राइवर",
      GULFSTREAM: "गल्फस्ट्रीम",
      MAINTENANCE: "रखरखाव",
      PERSONAL_VEHICLE: "निजी वाहन",
      SERVICE: "सेवा",
      SHUNT_DRIVER: "शंट ड्राइवर",
      SHUTTLE_DRIVER: "शटल ड्राइवर",
    },
    DUNNAGE: {
      "1_2": "1/2",
      "1_4": "1/4",
      FULL: "भरा हुआ",
    },
    ENTRY_PURPOSE: {
      BOBTAIL: "बाब्टेल",
      CARRIER_LOADED: "कैरियर लदा हुआ",
      CONTRACTOR: "ठेकेदार",
      CONTRACTOR_VISITOR: "ठेकेदार/विज़िटर",
      DELIVERY: "डिलिवरी",
      DROP: "ड्रॉप",
      DROP_HOOK: "ड्रॉप हुक",
      EMPTY: "खाली",
      EMPTY_TRAILER: "खाली ट्रेलर",
      FOODBANK: "फूडबैंक",
      FUEL: "ईंधन",
      LIVE_LOAD: "लाइव लोड",
      LOADED: "लोडेड",
      NFI_LOADED: "NFI लोडेड",
      OTHERS: "अन्य",
      PARKING: "पार्किंग",
      PICKUP_EMPTY: "पिकअप खाली",
      PICKUP_LOAD: "पिकअप लोड",
      PICK_UP: "पिकअप",
      PLANT_LOADED: "प्लांट लोडेड",
      PRIVATE: "निजी",
      REPAIR: "मरम्मत",
      VISITOR: "विज़िटर",
      WAAS_FAAS: "WAAS/FAAS",
      WASH: "धोना",
    },
    ENTRY_TYPE: {
      INBOUND: "इनबाउंड",
      INBOUND_ARRIVAL: "इनबाउंड / \nआगमन",
      INBOUND_DROP: "इनबाउंड / ड्रॉप",
      MAINTENANCE: "रखरखाव",
      OUTBOUND: "आउटबाउंड",
      OUTBOUND_DEPARTURE: "आउटबाउंड / \nप्रस्थान",
      OUTBOUND_PICKUP: "आउटबाउंड / पिकअप",
      WALMART_CARRIERS: "वॉलमार्ट कैरियर",
      YARD_STORAGE: "यार्ड भंडारण",
    },
    EQUIPMENT_LENGTH: {
      "20": "20",
      "40": "40",
      "48": "48",
      "53": "53",
    },
    EQUIPMENT_TYPE: {
      BOBTAIL: "बाब्टेल",
      CHASSIS: "चैसी",
      CONTAINER: "कंटेनर",
      TRAILER: "ट्रेलर",
      VAN: "वैन",
    },
    FUEL_LEVEL: {
      "1_2": "1/2",
      "1_4": "1/4",
      "1_8": "1/8",
      "3_4": "3/4",
      "3_8": "3/8",
      "5_8": "5/8",
      "7_8": "7/8",
      EMPTY: "खाली",
      FULL: "भरा हुआ",
    },
    GENERIC: {
      NO: "नहीं",
      YES: "हाँ",
    },
    LOADED_STATUS: {
      EMPTY: "खाली",
      LOADED: "लोडेड",
    },
    LOAD_DETAILS: {
      CONVERTER_1X: "CONVERTER_1X",
      CONVERTER_2X: "CONVERTER_2X",
      DRY: "सूखा",
      FROZEN: "जमा हुआ",
      HEAT: "गर्मी",
      "MULTI TEMP": "बहु तापमान",
      REEFER: "रीफर",
    },
    LOAD_TYPE: {
      BOBTAIL: "बाब्टेल",
      EMPTY: "खाली",
      LOADED: "लोडेड",
      OTHERS: "अन्य",
    },
    REEFER: {
      OFF: "बंद",
      ON: "चालू",
    },
    TRAILER_TYPE: {
      DRY: "सूखा",
      REEFER: "रीफर",
    },
    VISIT_TYPE: {
      DROP_AND_GO: "छोड़ें और जाएं",
      DROP_AND_WAIT: "छोड़ें और प्रतीक्षा करें",
      DROP_EMPTY: "ड्राप खाली",
      PICKUP_EMPTY: "पिकअप खाली",
    },
  },
  APP: {
    DEVELOPED_BY_EAIGLE: "EAIGLE द्वारा विकसित",
    INVALID_FACILITY: "फैसिलिटी नहीं मिली!",
    PAGE_NOT_FOUND: "पेज नहीं मिला। अमान्य मापदण्ड",
    PLEASE_ROTATE:
      "कृपया इस एप्लिकेशन का उपयोग करने के लिए अपने डिवाइस को पोर्ट्रेट मोड में घुमाएं।",
    POWERED_BY_EAIGLE: "<LOGO/> eaagle.com द्वारा संचालित",
  },
  AVAC: {
    ADD_COMMENT_HEADER: "कमेंट जोड़ें (आवश्यक)",
    AREA: {
      ISO: "ISO",
      TANK_WASH: "टैंक की धुलाई",
    },
    COMMENT_HERE: "अपना कमेंट यहां जोड़ें...",
    COMMENT_SUBMITTED: "कमेंट सबमिट हो गया",
    DETAILS: {
      ACTUAL_TEMPERATURE: "वास्तविक तापमान",
      ADDITIONAL_COMMENTS: "अतिरिक्त टिप्पणियां",
      ALLOCATED_PAD: "निर्धारित PAD",
      APPOINTMENT_INFORMATION: "अपॉइंटमेंट संबंधित जानकारी",
      APPOINTMENT_NUMBER: "अपॉइंटमेंट नंबर",
      APPOINTMENT_TIME: "अपॉइंटमेंट का समय",
      APPOINTMENT_TYPE: "अपॉइंटमेंट का प्रकार",
      AVAC_EVENT: "AVAC इवेंट",
      BOL_NUMBER: "BOL नंबर",
      BOOKING_NUMBER: "बुकिंग नंबर",
      BRE_STATUS: "BRE स्थिति",
      BROKER: "दलाल",
      CARRIER: "कैरियर",
      CARRIER_NAME: "कैरियर का नाम",
      CHASSIS_NUMBER: "चेसी नंबर",
      CHILD_SCAC: "चाइल्ड SCAC",
      COMMENT: "कमेंट",
      CVIP_DATE: "CVIP तिथि",
      CV_DETAILS: "CV विवरण",
      CV_EVENT_ID: "CV इवेंट आईडी",
      DELIVERY_NOTE: "डिलिवरी का नोट",
      DESCRIPTION: "विवरण",
      DRIVER_ENGAGEMENT_TIME: "ड्राइवर के साथ लगने वाला समय (सेकंड)",
      DRIVER_INFORMATION: "ड्राइवर की जानकारी",
      DRIVER_NAME: "ड्राइवर का नाम",
      DUNNAGE: "डननेज",
      ENTRY_SUBTYPE: "प्रवेश का उपप्रकार",
      ENTRY_TYPE: "प्रवेश का प्रकार",
      EQUIPMENT_LENGTH: "उपकरण की लंबाई",
      EQUIPMENT_LOADED_STATUS: "उपकरण लोड की स्थिति",
      EQUIPMENT_TYPE: "उपकरण का प्रकार",
      EQUIPMENT_TYPE_ID: "उपकरण के प्रकार की आईडी",
      EVENT_ID: "इवेंट की आईडी",
      EVENT_INFORMATION: "इवेंट की जानकारी",
      EVENT_TIME: "इवेंट का समय",
      EVENT_TYPE: "इवेंट का प्रकार",
      FAILURE_REASON: "असफलता का कारण",
      FIRST_NAME: "पहला नाम",
      FUEL_LEVEL: "ईंधन लेवल",
      GATE_ENGAGEMENT_TIME: "गेट पर लगने वाला समय (सेकंड)",
      ID: "आईडी",
      IMAGES: "इमेजिस",
      LANE_ID: "लेन आईडी",
      LANE_NAME: "लेन का नाम",
      LAST_NAME: "आखिरी नाम",
      LIVE_DROP: "लाइव ड्रॉप",
      LOAD_ID: "लोड की आईडी",
      LTL: "LTL",
      MC_NUMBER: "MC नंबर",
      OPERATOR_COMMENTS: "संचालक की टिप्पणियाँ",
      ORDER_NUMBER: "क्रम संख्या",
      PARENT_SCAC: "पेरेंट SCAC",
      PHONE_NUMBER: "फ़ोन नंबर",
      PLATE_NUMBER: "प्लेट नंबर",
      PO: "PO",
      PO_LOAD_DETAILS: "PO / लोड का विवरण",
      PO_NUMBER: "PO नंबर",
      RAIL_CARS: "रेल गाड़ियाँ",
      REFERENCE_NUMBER: "रेफ़रेंस नंबर",
      SCAC: "SCAC",
      SEAL_NUMBER: "सील नंबर",
      SET_TEMPERATURE: "तापमान सेट करें",
      SPOT_NUMBER: "स्पॉट नंबर",
      START_TIME: "शुरू होने का समय",
      STATUS: "स्थिति",
      TEMPERATURE: "तापमान",
      TIMESTAMP: "टाइमस्टैम्प",
      TRACTOR_ID: "ट्रैक्टर की आईडी",
      TRACTOR_NUMBER: "ट्रैक्टर का नंबर",
      TRAILER: "ट्रेलर",
      TRAILER_NUMBER: "ट्रेलर क नंबर",
      TRAILER_TYPE: "ट्रेलर का प्रकार",
      TRUCK_INFORMATION: "ट्रक संबंधी जानकारी",
      TRUCK_NUMBER: "ट्रक का नंबर",
      UNIT: "यूनिट",
      UNIT_ID: "यूनिट आईडी",
      UNIT_NUMBER: "यूनिट नंबर",
      UNIT_TYPE: "यूनिट का प्रकार",
      USDOT_NUMBER: "USDOT नंबर",
      VEHICLE_MEDIA: "वाहन मीडिया",
      VIDEOS: "वीडियो",
      WAC: "WAC",
      ZONE: "ज़ोन",
    },
    DRIVER_ASSIST: "ड्राइवर सहायता",
    DRIVER_CREATED: "ड्राइवर सफलतापूर्वक बनाया गया!",
    DRIVER_PIN: "ड्राइवर पिन:",
    DRIVER_QR_CODE: "ड्राइवर QR कोड",
    DRIVER_UPDATED: "ड्राइवर सफलतापूर्वक अपडेट किया गया!",
    ERROR: {
      ACCESS_DENIED: "पहुँच अस्वीकृत",
      ACCESS_DENIED_DETAILS: "आपके पास इस मॉड्यूल तक पहुँच नहीं है।",
      AUTH_ERROR: "प्रमाणीकरण त्रुटि: {{ERROR}}",
      CONTACT_ADMIN: "कृपया अनुमति के लिए अपने ऐडमिनिस्ट्रेटर से संपर्क करें।",
      ERROR_CREATING_DRIVER: "ड्राइवर बनाते समय एक त्रुटि हुई",
      ERROR_UPDATING_DRIVER: "ड्राइवर अपडेट करते समय एक त्रुटि हुई",
      FAILED_TO_CREATE_DRIVER: "ड्राइवर बनाने में विफल",
      FAILED_TO_FETCH_FACILITIES: "फैसिलिटीज़ प्राप्त करने में विफल",
      FAILED_TO_UPDATE_DRIVER: "ड्राइवर अपडेट करने में विफल",
      LOADING_EVENT_DETAILS_AVAC:
        "ईवेंट का विवरण लोड करने में त्रुटि। AVAC पर दोबारा भेजा जा कर रहा है...",
      LOADING_EVENT_DETAILS_GATE_LOG:
        "ईवेंट का विवरण लोड करने में त्रुटि। गेट लॉग पर दोबारा भेजा जा कर रहा है...",
      MISSING_EMAIL_AND_PHONE_NUMBER: "कृपया एक ईमेल पता या फ़ोन नंबर प्रदान करें",
      NO_FACILITY_SELECTED: "कोई फैसिलिटी नहीं चुनी गई",
      WEBSOCKET_ERROR: "WebSocket त्रुटि: {{ERROR}}",
    },
    FACILITY: "फैसिलिटी",
    FAILED_EVENTS: "विफल ईवेंट",
    HISTORICAL_EVENTS: "ऐतिहासिक ईवेंट (अंतिम दिन)",
    IMAGE_MODAL_INSTRUCTIONS:
      "ज़ूम करने के लिए स्क्रॉल करें • ज़ूम करने के बाद पैन करने के लिए खींचें",
    NEW_DRIVER: {
      PIN_SENT: "ड्राइवर के ईमेल और फ़ोन नंबर पर पिन भेज दिया गया है।",
      QR_CODE_AND_PIN_SENT:
        "ड्राइवर के ईमेल और फ़ोन नंबर पर QR कोड और पिन भेज दिए गए हैं।",
      QR_CODE_SENT: "ड्राइवर के ईमेल और फ़ोन नंबर पर QR कोड भेज दिया गया है।",
    },
    NO_APPROVED_EVENTS: "चयनित तिथि सीमा के लिए कोई स्वीकृत इवेंट नहीं मिला",
    NO_EVENTS: "कोई इवेंट उपलब्ध नहीं है",
    NO_FAILED_EVENTS: "पिछले दिन में कोई असफल इवेंट नहीं मिला",
    NO_INVENTORY: "कोई इन्वेंट्री आइटम नहीं मिली।",
    NO_LANES: "कोई लेन उपलब्ध नहीं है।",
    NO_MATCHES: "कोई मिलान नहीं मिला",
    NO_NON_FAILURE_EVENTS: "पिछले दिन कोई गैर-असफल इवेंट नहीं मिला",
    NO_VEHICLE_MEDIA: "कोई वाहन मीडिया उपलब्ध नहीं है",
    PRODUCT_NAME: "AVAC™",
    READ_AND_AGREE: "<BUTTON>छूट फ़ॉर्म</BUTTON> पढ़ें\nऔर उससे सहमत हों",
    SELECT_LANE: "लेन चुनें",
    SUBMITTING: "सबमिट किया जा रहा है...",
    SUGGESTION: {
      EMAIL_OR_PHONE_NUMBER: "ईमेल या फ़ोन नंबर फ़ील्ड भरें",
    },
    TOAST: {
      APPROVE_EVENT_FAILED:
        "ईवेंट को स्वीकृत करने में असफल हुआ। कृपया दोबारा प्रयास करें।",
      EVENT_APPROVED: 'ईवेंट सफलतापूर्वक स्वीकृत! "गेट खोलें" बटन पर क्लिक करें।',
      EVENT_REJECTED: "ईवेंट अस्वीकृत।",
      GATE_OPENED: "गेट सफलतापूर्वक खुल गया!",
      OPEN_GATE_FAILED:
        "गेट खोलने में विफल। कृपया दोबारा प्रयास करें या सहायता टीम से संपर्क करें।",
      REJECT_EVENT_FAILED:
        "ईवेंट को अस्वीकार करने में असफल हुआ। कृपया दोबारा प्रयास करें।",
    },
    VALIDATING_ACCESS: "आपकी पहुँच सत्यापित की जा रही है...",
    VALIDATION: {
      INVALID_EMAIL: "कृपया एक मान्य ईमेल पता दर्ज करें",
      INVALID_NAME: "इसमें केवल अक्षर और रिक्त स्थान होने चाहिए",
      INVALID_PHONE_NUMBER: "कृपया 10-अंकों वाला एक मान्य फ़ोन नंबर दर्ज करें",
    },
  },
  BRE: {
    FAILED_TO_OPEN_GATE: "गेट खोलने में विफल",
    GATE_OPEN_FAILED: "गेट खोलने में विफलता",
    INVALID_APPOINTMENT: "अमान्य अपॉइंटमेंट",
    DRIVER_REGISTRATION_EXPIRED:
      "ड्राइवर पंजीकरण मान्य नहीं है। कृपया गेट ऑपरेटर से संपर्क करें।",
    INVALID_QRCODE_FORMAT: "अमान्य QR कोड फार्मेट",
    KRAFT: {
      APPOINTMENT_USAGE_EXCEEDED: "अपॉइंटमेंट उपयोग की सीमा पार हो गई है",
      BOL_CALL_FAILED: "BOL कॉल विफल",
      BOL_CALL_FAILED_NO_LANE_EVENT: "BOL कॉल विफल या InProgress CVLaneEvent नहीं मिला",
      BOL_PO_MISSING: "अपॉइंटमेंट में BOL/PO नंबर मौजूद नहीं है",
      BOL_PO_MISSING_NO_LANE_EVENT:
        "अपॉइंटमेंट में BOL/PO नंबर मौजूद नहीं है और InProgress CVLaneEvent नहीं मिला",
      CVLANE_EVENT_NOT_FOUND: "CVLaneEvent मौजूद नहीं है",
      EVENT_OUTSIDE_OPERATION_HOURS: "संचालन के समय से बाद का ईवेंट",
      FAILED_OBTAIN_BOL_INFO: "BOL जानकारी प्राप्त करने में विफल",
      FUEL_LEVEL_BELOW_THRESHOLD:
        "ईंधन लेवल 0.75 से कम है और InProgress CVLaneEvent नहीं मिला",
      FUEL_LEVEL_BELOW_THRESHOLD_NO_LANE_EVENT:
        "ईंधन लेवल 0.75 से कम है और InProgress CVLaneEvent नहीं मिला",
      INTERNAL_FAILURE: "आंतरिक विफलता",
      INVALID_APPOINTMENT_ENTRY_SUBTYPE: "अमान्य अपॉइंटमेंट प्रवेश उपप्रकार",
      INVALID_APPOINTMENT_ENTRY_TYPE: "अमान्य अपॉइंटमेंट प्रवेश प्रकार",
      INVALID_APPOINTMENT_QR_CODE: "अमान्य अपॉइंटमेंट QR कोड",
      INVALID_ENTRY_SUBTYPE: "अमान्य प्रवेश उपप्रकार",
      INVALID_ENTRY_SUBTYPE_IN_APPOINTMENT: "अपॉइंटमेंट में अमान्य प्रवेश उपप्रकार",
      INVALID_ENTRY_SUBTYPE_NO_LANE_EVENT:
        "अपॉइंटमेंट और InProgress CVLaneEvent में अमान्य प्रवेश उपप्रकार",
      INVALID_INBOUND_BOBTAIL_PLATE_NUMBER: "इनबाउंड बॉबटेल प्लेट नंबर अमान्य",
      INVALID_OUTBOUND_EMPTY_APPOINTMENT_USAGE: "आउटबाउंड खाली अपॉइंटमेंट उपयोग अमान्य",
      INVALID_QRCODE_SOURCE: "QR कोड स्रोत अमान्य",
      MAX_APPOINTMENT_LIMIT_REACHED: "अपॉइंटमेंट उपयोग की अधिकतम सीमा पूरी हो गई है",
      NO_CV_LANE_EVENT_FOUND_OR_UNSUPPORTED_APPOINTMENT_MISMATCH_USAGE:
        "कोई CV LaneEven नहीं मिला या असमर्थित अपॉइंटमेंट बेमेल उपयोग",
      NO_INPROGRESS_LANE_EVENT_FOUND: "कोई InProgress LaneEvent नहीं मिला",
      NO_INPROGRESS_LANE_EVENT_FOUND_OR_TRAILER_NUMBER_IS_PRESENT_IN_THE_RECORD:
        "रिकॉर्ड में कोई InProgress LaneEvent नहीं मिला या ट्रेलर नंबर रिकॉर्ड में मौजूद है",
      NO_USER_INFO_RECEIVED: "कोई उपयोगकर्ता जानकारी प्राप्त नहीं हुई",
      NO_VEHICLE_DETECTED: "कोई वाहन नहीं मिला या वाहन का प्रकार अमान्य है",
      NO_VEHICLE_DETECTED_BOBTAIL: "कोई वाहन नहीं मिला या यह बॉबटेल नहीं है",
      PLEASE_PROCEED_TO_DOCK_OFFICE: "कृपया डॉक ऑफिस जाएँ",
      SEAL_NUMBER_MISMATCH: "सील नंबर मेल नहीं खाता",
      SEAL_NUMBER_MISSING: "आउटबाउंड लोडेड रिकॉर्ड का सील नंबर मौजूद नहीं है",
      TEMPERATURE_EXCEEDS_LIMIT: "तापमान सीमा से अधिक है",
      TEMPERATURE_INFO_MISSING:
        "तापमान संबंधी जानकारी मौजूद नहीं है और वर्तमान मौसम के कारण, तापमान जाँच को नज़रअंदाज़ नहीं किया जा सकता",
      TEMPERATURE_INFO_MISSING_NO_LANE_EVENT:
        "तापमान संबंधी जानकारी मौजूद नहीं है और वर्तमान मौसम के कारण, तापमान जाँच को नज़रअंदाज़ नहीं किया जा सकता। InProgress CVLaneEvent नहीं मिला",
      TEMPERATURE_INFO_NOT_INCLUDED: "अपॉइंटमेंट में तापमान संबंधी जानकारी शामिल नहीं थी",
      TEMPERATURE_INFO_NOT_INCLUDED_NO_LANE_EVENT:
        "अपॉइंटमेंट में तापमान संबंधी जानकारी शामिल नहीं थी और InProgress CVLaneEvent नहीं मिला",
      TRAILER_NUMBER_DOES_NOT_MATCH: "ट्रेलर का नंबर मेल नहीं खाता।",
      TRAILER_NUMBER_DOES_NOT_MATCH_WITH_RECORD:
        "ट्रेलर का नंबर रिकॉर्ड से मेल नहीं खाता",
      TRAILER_NUMBER_IS_NOT_AVAILABLE: "ट्रेलर का नंबर उपलब्ध नहीं है",
      TRAILER_NUMBER_MISSING: "ट्रेलर का नंबर मौजूद नहीं है या रिकॉर्ड से मेल नहीं खाता",
      TRAILER_NUMBER_NOT_PRESENT: "अपॉइंटमेंट में ट्रेलर का नंबर मौजूद नहीं है",
      TRAILER_NUMBER_SHOULD_NOT_EXIST: "रिकॉर्ड में ट्रेलर का नंबर मौजूद नहीं होना चाहिए",
      UNABLE_TO_VALIDATE_TEMPERATURE: "तापमान को सत्यापित नहीं किया जा सका",
      UNSUPPORTED_APPOINTMENT_TYPE: "असमर्थित अपॉइंटमेंट प्रकार का मिलान नहीं हो पाया",
    },
    LACTALIS: {
      APPOINTMENT_DOES_NOT_EXIST: "अपॉइंटमेंट मौजूद नहीं है",
      OFF_HOURS_OUTBOUND_TRAILER:
        "काम के समय के बाद ट्रेलर के साथ बाहर जाने वाले वाहनों को इंटरकॉम का इस्तेमाल करना चाहिए",
      OUTBOUND_TRAFFIC_WORKING_HOURS:
        "काम के समय के दौरान बाहर जाने वाले वाहनों को इंटरकॉम का इस्तेमाल करना चाहिए",
      YMS_CHECKIN_FAILED: "YMS चेकइन विफल। कृपया गेट ऑपरेटर से संपर्क करें",
    },
    LOBLAW: {
      ENTRY_APPROVED: "प्रवेश स्वीकृत। कृपया पैड {{MESSAGE}} पर जाएं",
      INVALID_INFORMATION: "अमान्य जानकारी",
      PROCEED_TO_DISPATCH: "{{MESSAGE}} कृपया विवरण के लिए डिस्पैच ऑफिस जाएँ।",
      SEE_YOU_NEXT_TIME: "{{MESSAGE}} फिर मिलेंगे।",
    },
    PORTCITY: {
      AFTER_HOURS_ENTRY:
        "काम के समय के बाद प्रवेश के लिए, कृपया सेंटर लेन में नंबर कीपैड का उपयोग करें। कोड आपके डिस्पैच द्वारा प्रदान किया गया है",
      BOOKING_NUMBER_PROVIDED_NOT_VALID: "प्रदान किया गया बुकिंग नंबर मान्य नहीं है",
      INVALID_EAIGLE_APPOINTMENT_RECORD: "Eaigle अपॉइंटमेंट रिकॉर्ड अमान्य है",
      INVALID_PROFILE_OR_EXPIRED_CREDENTIAL:
        "प्रोफ़ाइल अमान्य है या क्रेडेंशियल समाप्त हो गया है",
      IT_IS_NOT_AN_OUTBOUND_BOBTAIL: "यह आउटबाउंड बॉबटेल नहीं है",
      IT_IS_NOT_A_BOBTAIL: "यह बाब्टेल नहीं है",
      LOADID_PROVIDED_IS_NOT_VALID: "प्रदान की गई लोड आईडी मान्य नहीं है",
      NO_BOOKING_NUMBER_PROVIDED: "कोई बुकिंग नंबर प्रदान नहीं किया गया",
      NO_INPROGRESS_CV_LANE_EVENT_FOUND: "कोई InProgress CV LaneEvent नहीं मिला",
      NO_LOADID_PROVIDED: "कोई लोड आईडी प्रदान नहीं की गई",
      PICK_UP_BOL: "{{MESSAGE}} द्वार 25 पर BOL को पिक करें",
      PLEASE_CONTACT_SECURITY_TO_OPEN_GATE:
        "गेट खोलने के लिए कृपया सुरक्षा विभाग से संपर्क करें",
      UNSUPPORTED_APPOINTMENT_TYPE: "असमर्थित अपॉइंटमेंट प्रकार",
      UNSUPPORTED_OPERATION_TYPE: "असमर्थित संचालन प्रकार",
    },
    TRIMAC: {
      NOT_A_VALID_REQUEST: "मान्य अनुरोध नहीं",
    },
  },
  CARRIER: {
    SCAC_AND_NAME: "{{SCAC}} ({{NAME}})",
    NAME_AND_SCAC: "{{NAME}} ({{SCAC}})",
  },
  CATEGORY: {
    ACTUAL_TEMPERATURE: "वास्तविक तापमान",
    ACTUAL_TEMPERATURE_F: "वास्तविक तापमान °F",
    COMPANY: "कंपनी की जानकारी",
    EQUIPMENT_DETAILS: "उपकरण का विवरण",
    LOAD_DETAILS: "लोड का विवरण",
    PERSONAL: "व्यक्तिगत जानकारी",
    PURPOSE_DETAILS: "उद्देश्य का विवरण",
    SAFETY: "सुरक्षा",
    SET_TEMPERATURE: "तापमान सेट करें",
    SET_TEMPERATURE_F: "तापमान °F सेट करें",
    SHIPPING_DETAILS: "शिपिंग का विवरण",
    SHIPPING_DETAILS_WITHOUT_VALIDATION: "सत्यापन के बिना शिपिंग का विवरण",
    SHIPPING_DETAILS_WITH_VALIDATION: "सत्यापन के साथ शिपिंग का विवरण",
    VEHICLE_EQUIPMENT_DETAILS: "वाहन/उपकरण का विवरण",
    VISIT_PURPOSE: "विज़िट का उद्देश्य",
  },
  COMMAND: {
    ADD_NEW_DRIVER: "नया ड्राइवर जोड़ें",
    APPROVE: "स्वीकृति दें",
    BACK: "वापस",
    BACK_TO_EVENTS: "ईवेंट पर वापस",
    CHECK_IN: "चेक-इन",
    CHECK_OUT: "चेक-आउट",
    CLEAR: "साफ़ करें",
    CLICK_TO_EDIT: "संपादित करने के लिए क्लिक करें",
    CLOSE: "बंद करें",
    CLOSE_IMAGE_MODAL: "इमेज मॉडल बंद करें",
    DELETE: "हटाएँ",
    EDIT: "संपादित करें",
    LOGOUT: "लॉगआउट करें",
    NEXT: "अगला",
    OPEN_GATE: "गेट खोलें",
    REJECT: "अस्वीकार करें",
    RETURN: "वापस जाएं",
    SELECT_END: "समाप्त चुनें",
    SELECT_START: "प्रारंभ चुनें",
    SSO_LOGIN: "Azure AD पर साइन इन करें",
    START_NEW_REGISTRATION: "नया पंजीकरण शुरू करें",
    SUBMIT: "सबमिट करें",
    TODAY: "आज",
    UPDATE: "अपडेट करें",
  },
  DAY: {
    "0": "रवि",
    "1": "सोम",
    "2": "मंगल",
    "3": "बुध",
    "4": "गुरु",
    "5": "शुक्र",
    "6": "शनि",
  },
  ERROR: {
    VIDEO_NOT_SUPPORTED: "आपका ब्राउज़र वीडियो टैग का समर्थन नहीं करता है।",
  },
  ERROR_MODAL: {
    INVALID_X: "अमान्य {{TITLE}}",
  },
  EVENT_STATUS: {
    APPROVED: "स्वीकृत",
    FAILURE: "विफलता",
    INPROGRESS: "inprogress",
    REJECTED: "अस्वीकृत",
    SUCCESS: "सफलता",
  },
  FAILURE_PAGE: {
    BODY: "कियोस्क पर इंटरकॉम बटन दबाएँ",
    FAILURE: "विफलता",
    HEADER: "जानकारी सत्यापित नहीं है!",
    INTERCOM: "इंटरकॉम",
  },
  FILTER: {
    CARD: {
      EVENT_TYPE: "ईवेंट प्रकार",
      STATUS: "स्थिति",
      TIME: "समय",
      TRAILER_LOGO: "ट्रेलर लोगो",
    },
    EVENT_TYPE: {
      JB_HUNT: "JB Hunt",
    },
    LOGO: {
      AB: "AB",
      CD: "CD",
      DH: "DH",
      EF: "EF",
    },
    STATUS: {
      CLEAN: "साफ़",
      DIRTY: "गंदा",
      EMPTY: "खाली",
      INBOUND: "इनबाउंड",
      LOADED: "लोडेड",
      OUTBOUND: "आउटबाउंड",
    },
    TIME: {
      LAST_24_HOURS: "पिछले 24",
      LAST_MONTH: "पिछला महीना",
      LAST_WEEK: "पिछला सप्ताह",
      LAST_YEAR: "पिछला वर्ष",
      TODAY: "आज",
    },
  },
  FORM_INPUT: {
    COMMAND: {
      ENTER_SCAC: "मैन्युअल रूप से SCAC दर्ज करने के लिए क्लिक करें",
      SELECT_SCAC: "उपलब्ध SCAC कोड में से चुनने के लिए क्लिक करें",
      SHOW_LESS: "कम दिखाएँ",
      SHOW_MORE: "ज़्यादा दिखाएँ",
    },
    FIELD_IS_REQUIRED: "यह फ़ील्ड आवश्यक है",
    NO_MATCHES: "कोई मिलान नहीं मिला",
    REQUIRED_LABEL: "{{TEXT}}*",
    SELECT: "खोजें या चुनें...",
    SELECT_CARRIER: "कैरियर खोजें या चुनें...",
    SELECT_DATE: "दिनांक चुनें",
    SELECT_OPTIONS: "विकल्प चुनें...",
    TRUNCATED: "{{TEXT}}...",
  },
  FORM_PAGE: {
    COMMAND: {
      NEXT: "अगला",
      SUBMIT: "सबमिट करें",
    },
    ERROR: {
      UNABLE_TO_SUBMIT:
        "फ़ॉर्म सबमिट नहीं किया जा सका। कृपया बाद में दोबारा प्रयास करें।",
    },
    VALIDATING: "सत्यापित किया जा रहा है...",
  },
  HINT: {
    EDIT_SEAL_NUMBER: "* यदि आवश्यक हो, तो भरे गए सील नंबर को संपादित करें।",
    LOAD_ID_8_DIGITS: "आपकी लोड आईडी एक 8-अंकों वाला नंबर है जो 4 से शुरू होता है।",
    SCAC_NOT_LISTED_CPU9: "यदि आपका SCAC सूचीबद्ध नहीं है, तो कृपया CPU9 दर्ज करें।",
  },
  IDCAPTURE: {
    CAMERA_ERROR: {
      BODY: "हम आपके कैमरे को एक्सेस नहीं कर सके। कृपया अनुमतियों की जाँच करें और दोबारा प्रयास करें।",
      HEADER: "कैमरा एक्सेस में त्रुटि",
    },
    COMMAND: {
      CAPTURE: "कैप्चर आईडी",
      CAPTURING: "कैप्चर हो रहा है...",
      CHANGE_TYPE: "आईडी का प्रकार बदलें",
      DONE: "हो गया",
      RETAKE_PHOTOS: "फ़ोटो दोबारा लें",
      SUBMIT: "सबमिट करें",
      SWITCH_CAMERA: "कैमरा बदलें",
      TRY_AGAIN: "दोबारा प्रयास करें",
      TRY_BACK: "पीछे वाला कैमरा आज़माएँ",
      TRY_FRONT: "आगे वाला कैमरा आज़माएँ",
    },
    EMPLOYEE_ID_BACK: "कर्मचारी आईडी (पीछे वाला हिस्सा)",
    EMPLOYEE_ID_BACK_ALT: "कर्मचारी आईडी पीछे वाला हिस्सा",
    EMPLOYEE_ID_FRONT: "कर्मचारी आईडी (आगे वाला हिस्सा)",
    EMPLOYEE_ID_FRONT_ALT: "कर्मचारी आईडी आगे वाला हिस्सा",
    ERROR: {
      EXPIRED: "आईडी की समय सीमा समाप्त हो गई है। कृपया एक मान्य आईडी प्रदान करें।",
      GENERIC: "कुछ गड़बड़ हो गई",
      NO_CAMERA:
        "किसी भी कैमरा डिवाइस को एक्सेस नहीं किया जा सकता। कृपया अपना कैमरा कनेक्ट करें या कोई दूसरा ब्राउज़र आज़माएँ।",
      NO_SWITCH:
        "केवल एक ही वीडियो डिवाइस का एक्सेस होने के कारण, कैमरा को दूसरे ब्राउज़र पर स्विच करना संभव नहीं है।",
      PERMISSION_DENIED: "अनुमति अस्वीकृत। कृपया रीफ़्रेश करें और कैमरा की अनुमति दें।",
      UNREADABLE: "आईडी जानकारी नहीं पढ़ी जा सकी।",
      UNSUPPORTED: "कैनवस समर्थित नहीं है।",
      UPLOAD_FAILED: "कर्मचारी की आईडी की तस्वीरें अपलोड करने में विफल",
      UPLOAD_FAILED_TRY_AGAIN:
        "कर्मचारी की आईडी की तस्वीरें अपलोड करने में विफल। कृपया दोबारा प्रयास करें।",
      VERIFY_FAILED_TRY_AGAIN: "आईडी सत्यापित करने में विफल। कृपया दोबारा प्रयास करें।",
    },
    ID_INFORMATION: "आईडी संबंधी जानकारी",
    ID_NOT_VERIFIED_MESSAGE:
      "हम आपकी आईडी पूरी तरह से सत्यापित नहीं कर सके। कृपया नीचे दिए गए विवरण देखें।",
    ID_NOT_VERIFIED_STATUS: "आईडी के सत्यापन संबंधी समस्याएँ",
    ID_VERIFIED_MESSAGE: "आपकी पहचान सफलतापूर्वक सत्यापित हो गई है।",
    ID_VERIFIED_STATUS: "आईडी का सत्यापन सफल",
    INSTRUCTIONS: {
      DRIVERS_LICENSE:
        "अपने ड्राइविंग लाइसेंस को फ़्रेम में रखें और अच्छी रोशनी सुनिश्चित करें।",
      EMPLOYEE_ID_BACK: "अब अपनी कर्मचारी आईडी के पीछे वाले हिस्से को फ़्रेम में रखें।",
      EMPLOYEE_ID_FRONT: "अपनी कर्मचारी आईडी के आगे वाले हिस्से को फ़्रेम में रखें।",
    },
    PROCESSING: "प्रोसेस हो रहा है...",
    SELECT_TYPE: "आईडी का प्रकार चुनें",
    TYPE: {
      DRIVERS_LICENSE: "ड्राइवर लाइसेंस",
      EMPLOYEE_ID: "कर्मचारी आईडी",
    },
  },
  IMAGE_PREVIEW: {
    CAPTURED_ID: "कैप्चर की गई आईडी",
    COMMAND: {
      RETAKE: "दोबारा लें",
      SUBMIT: "सबमिट करें",
    },
    PLEASE_WAIT: "कृपया प्रतीक्षा करें जब तक हम आपकी जानकारी सत्यापित करते हैं",
    PROCESSING_ID: "आपकी आईडी प्रोसेस हो रही है...",
    SUBMITTING: "सबमिट हो रही है...",
    TIP: "सुनिश्चित करें कि इमेज स्पष्ट और पढ़ने योग्य है।",
  },
  KIOSK: {
    COMMAND: {
      ENTER: "दर्ज करें",
      REGISTER_NOW: "अभी पंजीकरण करें",
    },
    ERROR: {
      CONNECTION_CLOSED: "कनेक्शन बंद हो गया",
      CONNECTION_ERROR: "कनेक्शन में त्रुटि",
      ENTRY_TYPE_INVALID: 'प्रवेश का प्रकार "{{TYPE}}" अमान्य है',
      ENTRY_TYPE_MISSING: "प्रवेश का प्रकार मौजूद नहीं है",
      FAILED_TO_CONNECT: "कनेक्शन स्थापित करने में विफल",
      INFORMATION_NOT_VERIFIED_USE_INTERCOM:
        "जानकारी सत्यापित नहीं हुई! इंटरकॉम का उपयोग करें",
      INTERACTION_TYPE_INVALID: 'इंटरैक्शन का प्रकार "{{TYPE}}" अमान्य है',
      INTERACTION_TYPE_MISSING: "इंटरैक्शन का प्रकार मौजूद नहीं है",
      INTERMITTENT_CONNECTION:
        "आंतरायिक कनेक्शन में त्रुटि\nयदि समस्या बनी रहती है, तो कृपया 1 888 771 1584 पर EAIGLE सहायता से संपर्क करें",
      INTERMITTENT_CONNECTION_N:
        "आंतरायिक कनेक्शन त्रुटि {{N}}; यदि समस्या बनी रहती है, तो कृपया EAIGLE सपोर्ट  से 1 888 771 1584 पर संपर्क करें",
      MISSING_REQUIRED_INFO: "आवश्यक जानकारी मौजूद नहीं है",
      PROCESSING_ERROR: "आपके अनुरोध को प्रोसेस करने में त्रुटि। इंटरकॉम का उपयोग करें",
      VALIDATION_FAILED: "सत्यापन प्रक्रिया विफल",
      VALIDATION_TIMEOUT: "सत्यापन समय समाप्त",
    },
    FOOTER: {
      NOT_REGISTERED: "पंजीकृत नहीं हैं?",
    },
    GATE_OPEN: "गेट खुल गया",
    INFORMATION_VERIFIED: "जानकारी सत्यापित!",
    INVALID_URL_PARAMETERS: "अमान्य URL पैरामीटर",
    KEY: {
      BACKSPACE: "बैकस्पेस",
      CLEAR: "साफ़ करें",
      CLOSE: "बंद करें",
    },
    KEY_PAD_INSTRUCTIONS: "OTP दर्ज करें",
    PLEASE_ROTATE_LANDSCAPE: "कृपया अपने डिवाइस को लैंडस्केप मोड में घुमाएँ",
    PLEASE_WAIT_X: "कृपया प्रतीक्षा करें। {{TEXT}}",
    PRE_REGISTERED: "पूर्व-पंजीकृत?",
    PROCEED_TO_EXIT: "कृपया बाहर जाएं",
    PROCEED_TO_ZONE: "निर्धारित क्षेत्र की ओर जाएं",
    REDIRECTING: "रीडायरेक्ट हो रहा है...",
    SCAN_QR_CODE:
      "<br/> स्कैनिंग के लिए कियोस्क पर अपना पूर्व-पंजीकृत <br/> QR कोड रखें।",
    SECONDS_REMAINING: "{{N}} सेकंड बाकी",
    TROUBLE_SCANNING_QR_CODE:
      "QR कोड स्कैन करने में समस्या - अपॉइंटमेंट कोड मैन्युअल रूप से दर्ज करने के लिए यहाँ दबाएँ",
    VALIDATION: {
      PERSON_NAME: "केवल अक्षर और स्पेस",
      PHONE_NUMBER: "उदाहरण के लिए, 1234567890",
    },
    VERIFYING_INFORMATION: "जानकारी सत्यापित की जा रही है...",
    VIDEO_NOT_AVAILABLE: "लाइव वीडियो उपलब्ध नहीं है",
    WAIT_VERIFY_INFO: "कृपया प्रतीक्षा करें जब तक हम आपकी जानकारी सत्यापित करते हैं",
    WAIT_VERIFY_QR: "कृपया QR कोड के सत्यापित होने तक प्रतीक्षा करें",
  },
  LABEL: {
    APPROVED: "स्वीकृत",
    AREA: "क्षेत्र",
    CARRIER: "कैरियर",
    CHECK_ICON: "चेक आइकन",
    CHECK_IN_TIME: "चेक-इन समय",
    CHECK_OUT_TIME: "चेक-आउट समय",
    DETENTION_TIME: "डिटेन्शन समय",
    INDICATORS: "संकेतक",
    DETENTION_TIME_HOURS: "डिटेन्शन समय (घंटे)",
    DRIVERS: "ड्राइवर",
    DURATION: "अवधि",
    ERROR_ICON: "त्रुटि आइकन",
    FIRST_NAME_LAST_NAME: "{{FIRST}} {{LAST}}",
    FROM_DATE_TIME_TZ: "से: {{DATE_TIME_TZ}}",
    GATE_LOG: "गेट लॉग",
    GATE_OPEN: "गेट खुल गया",
    LOCATION: "स्थान",
    NOT_APPLICABLE: "लागू नहीं",
    OPENING: "खुल रहा है...",
    REGISTRATION: "पंजीकरण",
    ROW: "पंक्ति",
    SECTION_N: "{{SECTION}} {{N}}",
    SPOT: "स्थान",
    STEP_N: "चरण {{N}}",
    TANKER: "टैंकर",
    TIME: "समय",
    TIME_STAMP: "टाइम स्टेम्प",
    TOTAL_RECORDS_N: "कुल रिकॉर्ड: {{N}}",
    TO_DATE_TIME_TZ: "तक: {{DATE_TIME_TZ}}",
    UNIT_1: "यूनिट 1",
    UNIT_HISTORY: "यूनिट इतिहास",
    UNIT_ID: "यूनिट आईडी",
    UNIT_TYPE: "यूनिट का प्रकार",
    YARD_CHECK: "यार्ड जाँच",
    YARD_INVENTORY: "यार्ड इन्वेंटरी",
    ZOOMABLE_TYPE: "ज़ूम करने योग्य {{TYPE}}",
  },
  MONTH: {
    "1": "जनवरी",
    "2": "फ़रवरी",
    "3": "मार्च",
    "4": "अप्रैल",
    "5": "मई",
    "6": "जून",
    "7": "जुलाई",
    "8": "अगस्त",
    "9": "सितंबर",
    "10": "अक्टूबर",
    "11": "नवंबर",
    "12": "दिसंबर",
  },
  NAVBAR: {
    COMMAND: {
      PREVIOUS: "पिछला",
    },
    DRIVER_REGISTRATION: "ड्राइवर का पंजीकरण",
    LOGO: "लोगो",
  },
  PASSCODE_PAGE: {
    COMMAND: {
      VERIFY: "सत्यापन करें",
    },
    ENTER_PASSCODE: "पासकोड दर्ज करें",
    ERROR: {
      INVALID_PASSCODE: "अमान्य पासकोड",
    },
  },
  PLACEHOLDER: {
    ACTUAL_TEMPERATURE_F: "वास्तविक तापमान (°F)",
    BOL_OR_PO_NUMBERS: "BOL(s) / PO(s)",
    BOOKING_NUMBER: "बुकिंग नंबर",
    CARRIER: "कैरियर",
    CARRIER_NAME_PARENT_SCAC: "कैरियर का नाम (पेरेंट SCAC कोड)",
    CARRIER_SCAC: "कैरियर का SCAC दर्ज करें",
    COMPANY_NAME: "कंपनी का नाम",
    CURRENT_TEMPERATURE_F: "वर्तमान तापमान (°F)",
    CVIP_DATE: "CVIP तिथि",
    DRIVER_FIRST_NAME: "ड्राइवर का पहला नाम",
    DRIVER_LAST_NAME: "ड्राइवर का अंतिम नाम",
    DRIVER_NAME: "ड्राइवर का नाम",
    DRIVER_TYPE: "ड्राइवर का प्रकार",
    DUNNAGE: "डननेज",
    EMAIL: "ईमेल",
    EMAIL_ADDRESS: "ईमेल पता",
    ENTRY_TYPE_REASON: "प्रवेश का प्रकार (विज़िट का कारण)",
    EQUIPMENT_LENGTH: "उपकरण की लंबाई",
    EQUIPMENT_LOADED_STATUS: "उपकरण लोड की स्थिति",
    EQUIPMENT_TYPE: "उपकरण का प्रकार",
    FIRST_NAME: "पहला नाम",
    FUEL_LEVEL: "ईंधन लेवल",
    ID_VALIDATION: "आईडी सत्यापन",
    I_AGREE: "मैं सहमत हूँ",
    LAST_NAME: "अंतिम नाम",
    LOAD_ID: "लोड आईडी",
    LOAD_ID_NUMBER: "लोड आईडी नंबर",
    OUTBOUND_BOL: "आउटबाउंड BOL",
    PHONE_NUMBER: "फ़ोन नंबर",
    PO_NUMBER: "PO नंबर",
    PO_NUMBER_OR_LOAD_ID: "PO नंबर, ASN या लोड/रेफ़रेंस आईडी",
    PPE_DOCK_SAFETY: "PPE और डॉक सुरक्षा",
    PPE_DOCK_SAFETY_ASSISTANCE:
      "यदि आपको डॉक सुरक्षा में सहायता की आवश्यकता है या PPE के संबंध में कोई चिंता है, तो कृपया चेकपॉइंट स्टेशन पर नियुक्त कर्मचारियों से मिलें।\n\nधन्यवाद",
    PPE_DOCK_SAFETY_COMPLIANCE:
      '"हाँ" चुनकर आप सभी लागू कानूनों और हमारी नीतियों का पालन करने के लिए सहमत होते हैं। अनधिकृत उपयोग, संशोधन या वितरण निषिद्ध है। हम किसी भी नुकसान के लिए ज़िम्मेदार नहीं हैं। अधिक जानकारी के लिए, हमारी गोपनीयता नीति और पूरी शर्तें देखें।\n\nडॉक सुरक्षा या PPE आवश्यकताओं का पालन न करने पर जुर्माना लग सकता है। यदि आपको डॉक सुरक्षा में सहायता की आवश्यकता है या PPE के संबंध में कोई चिंता है, तो कृपया चेकपॉइंट स्टेशन पर नियुक्त कर्मचारियों से मिलें।',
    REASON_FOR_ENTRY: "प्रवेश का कारण",
    REEFER_FUEL_LEVEL: "रीफर ईंधन लेवल",
    REEFER_ON: "रीफर चालू / बंद",
    SEAL_NUMBER: "सील नंबर",
    SEARCH_CARRIER: "कैरियर खोजें...",
    SELECT_FACILITY: "फैसिलिटी चुनें...",
    SELECT_X: "{{X}} चुनें",
    SIGNATURE: "हस्ताक्षर",
    TEMPERATURE_F: "तापमान (°F)",
    TRACTOR_CARRIER_NAME: "ट्रैक्टर कैरियर का नाम",
    TRACTOR_NUMBER: "ट्रैक्टर का नंबर",
    TRAILER_CARRIER_NAME: "ट्रेलर कैरियर का नाम",
    TRAILER_MIDDLE: "मध्य",
    TRAILER_NOSE: "नोज़",
    TRAILER_NUMBER: "ट्रेलर का नंबर",
    TRAILER_TAIL: "टेल",
    TRAILER_TYPE: "ट्रेलर का प्रकार",
    VALIDATION_PERIOD: "सत्यापन अवधि",
  },
  QUESTION: {
    ACTUAL_TEMPERATURE_F: "वास्तविक तापमान °F",
    APPOINTMENT_DETAILS: "अपॉइंटमेंट का विवरण",
    COMPANY_INFO: "कंपनी की जानकारी",
    CONFIRM_SEAL_AND_TRAILER_NUMBER:
      "पुष्टि करें कि सील बरकरार है और ट्रेलर का नंबर सही है",
    CONFIRM_TRAILER_CONDITION:
      "पुष्टि करें कि ट्रेलर में कोई मलबा नहीं है, टैंडेम पीछे खिसकाए गए हैं, और रीफर काम कर रहा है।",
    DRIVER_NAME: "ड्राइवर का नाम दर्ज करें",
    DRIVER_TYPE: "ड्राइवर का प्रकार",
    ENTRY_PURPOSE: "प्रवेश का उद्देश्य चुनें",
    ENTRY_TYPE: "अपने प्रवेश का प्रकार चुनें",
    EQUIPMENT_DETAILS: "उपकरण का विवरण",
    GENERIC: "जानकारी भरें",
    LOAD_DETAILS: "लोड का विवरण",
    LOAD_TYPE: "लोड का प्रकार चुनें",
    PERSONAL_INFO: "व्यक्तिगत जानकारी",
    PPE_DOCK_SAFETY: "PPE और डॉक सुरक्षा",
    SET_TEMPERATURE_F: "तापमान °F सेट करें",
    SHIPPING_DETAILS: "शिपिंग का विवरण",
    VEHICLE_DETAILS: "वाहन का विवरण",
    VISIT_TYPE: "अपनी विज़िट का प्रकार चुनें",
    WAIVER: "छूट",
  },
  STATUS: {
    ACTIVE: "सक्रिय",
    EXPIRED: "समाप्त",
    EXPIRING_SOON: "जल्द ही समाप्त हो रही है",
  },
  SUCCESS_PAGE: {
    COMMAND: {
      DOWNLOAD: "डाउनलोड करें",
      EMAIL: "ईमेल",
      HOME: "होम",
      MESSAGE: "संदेश",
      START_OVER: "फिर से शुरू करें",
    },
    DRIVER_CHECK_IN_SUCCESS: "चेक-इन सफलतापूर्वक शुरू हुआ",
    DRIVER_CHECK_OUT_SUCCESS: "चेक-आउट सफलतापूर्वक शुरू हुआ",
    GENERATING_QR_CODE: "QR कोड जनरेट हो रहा है!",
    PLEASE_CHECK_DASHBOARD: "स्थिति के लिए AVAC डैशबोर्ड देखें",
    PLEASE_SCAN_CODE: "कृपया कियोस्क पर अपना QR कोड स्कैन करें।",
    PLEASE_WAIT: "कृपया प्रतीक्षा करें...",
    QR_CODE_GENERATED: "QR कोड जनरेट हो गया है!",
  },
  SUGGESTION: {
    PO_NUMBER_OR_LOAD_ID: "PO नंबर या लोड आईडी फ़ील्ड भरें",
  },
  TITLE: {
    CARRIER: "कैरियर",
    CATEGORY: "श्रेणी",
    COMPANY_NAME: "कंपनी का नाम",
    EMAIL_ADDRESS: "ईमेल पता",
    ENTRY_SUB_TYPE: "प्रवेश का उपप्रकार",
    ENTRY_TYPE: "प्रवेश का प्रकार",
    FIRST_NAME: "पहला नाम",
    LAST_NAME: "अंतिम नाम",
    PHONE_NUMBER: "फ़ोन नंबर",
    REASON_FOR_ENTRY: "प्रवेश का कारण",
    REFERENCE_NUMBER: "रेफ़रेंस नंबर",
    SEAL_NUMBER: "सील नंबर",
    SIGNATURE: "हस्ताक्षर",
    TEMPERATURE: "तापमान",
    TRAILER_NUMBER: "ट्रेलर का नंबर",
    VALIDATION_PERIOD: "सत्यापन अवधि",
  },
  TOOLTIP: {
    ADD: "जोड़ें",
    ARROW: "तीर",
    COMPANY_LOGO: "कंपनी लोगो",
    DOWNLOAD: "डाउनलोड करें",
    LOGO: "लोगो",
    MENU: "मेनू",
    SORT_ASC: "आरोही क्रम में क्रमबद्ध करें",
    SORT_DESC: "अवरोही क्रम में क्रमबद्ध करें",
  },
  VALIDATION: {
    EMAIL_ADDRESS: "कृपया एक मान्य ईमेल पता दर्ज करें",
    ERROR: {
      BOL_VALIDATION_FAILED: "रेफ़रेंस नंबर सत्यापित करने में विफल।",
      FUEL_VALIDATION_FAILED: "रीफ़र आँकड़े प्राप्त करने में विफल",
      INVALID_BOOKING_NUMBER: "अमान्य बुकिंग नंबर",
      INVALID_FACILITY: "अमान्य फैसिलिटी",
      INVALID_LOAD_ID: "अमान्य लोड आईडी",
      LOAD_ID_VALIDATION_FAILED: "लोड आईडी नंबर सत्यापन विफल",
      PO_VALIDATION_FAILED: "अमान्य PO. दोबारा प्रयास करें या इनबाउंड क्लर्क से मिलें।",
      TRAILER_VALIDATION_FAILED: "ट्रेलर विवरण सत्यापित करने में विफल",
    },
    FLOAT: "कृपया मान्य नंबर दर्ज करें (उदाहरण: 123 या 123.45)",
    NUMERIC: "कृपया केवल नंबर दर्ज करें",
    PERSON_NAME: "केवल अक्षर और रिक्त स्थान होने चाहिए",
    PHONE_NUMBER: "फ़ोन नंबर का गलत फॉर्मेट",
    PO_NUMBER_OR_LOAD_ID: "कृपया PO नंबर या लोड आईडी प्रदान करें",
    TEMPERATURE_FROM_N20F_TO_P100F: "तापमान -20°F और 100°F के बीच होना चाहिए",
    VALIDATING_REFERENCE_NUMBER: "रेफ़रेंस नंबर सत्यापित किया जा रहा है",
    VALIDATING_TRAILER_DETAILS: "ट्रेलर का विवरण सत्यापित किया जा रहा है",
  },
} as const;
